import { AxiosPromise } from 'axios';

import { hosts } from '@/app/config';
import { BaseClient } from '@/clients/BaseClient/BaseClient';
import { ChatListItemDto } from '@/entities/chat';

class ChatOverviewClient extends BaseClient {
  getChatList(): AxiosPromise<ChatListItemDto[]> {
    return this.request({
      url: `${hosts.chatApi}/chat/`,
      method: 'GET',
    });
  }
}

export const chatOverviewClient = new ChatOverviewClient();
